<div>
  <ng-container *ngIf="!isEditing">
    <p *ngIf="question">
      <b>{{ question }}</b>
    </p>
    <p *ngIf="data" [innerHtml]="sanitizeHtml(data)"></p>
    <span *ngIf="!data">{{ placeholder }}</span>
    <i class="fa fa-edit" (click)="toggleEdit()"></i>
  </ng-container>
  <ng-container *ngIf="isEditing">
    <input
      [(ngModel)]="question"
      name="name"
      id="name_id"
      type="text"
      style="background-color: #dbdbdb !important"
      class="form-control m-2"
      placeholder="Enter question..."
      required
    />
    <angular-editor
      class="m-2"
      id="editor"
      [editor]="editor"
      [(ngModel)]="data"
      [toolbar]="toolbar"
      placeholder="Enter text here..."
    ></angular-editor>

    <button (click)="saveEdit()" class="btn btn-primary m-2">
      {{ "Form.SAVE" | translate }}
    </button>
  </ng-container>
</div>
